var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-card",
        { staticClass: "mb-3" },
        [
          _c("v-text-field", {
            attrs: {
              solo: "",
              "append-icon": "search",
              label: "Rechercher un produit",
              "hide-details": "",
              clearable: ""
            },
            model: {
              value: _vm.search,
              callback: function($$v) {
                _vm.search = $$v
              },
              expression: "search"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.selected && _vm.selected.length > 0,
              expression: "selected && selected.length > 0"
            }
          ],
          staticClass: "mb-3"
        },
        [
          _vm.checkRouteSendChat
            ? _c(
                "v-btn",
                {
                  attrs: { color: "secondary--text", icon: "" },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.pushManyProducts(_vm.selected)
                    },
                    mouseover: function($event) {
                      _vm.overMenu = true
                    },
                    mouseleave: function($event) {
                      _vm.overMenu = false
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                ENVOYER TOUS LES PRODUITS SELECTIONNES\n                "
                  ),
                  _c("v-icon", [_vm._v("shopping_cart_checkout")])
                ],
                1
              )
            : _c(
                "v-btn",
                {
                  attrs: {
                    color:
                      _vm.status === "offline"
                        ? "grey--text"
                        : "secondary--text",
                    icon: ""
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.pushManyProducts(_vm.selected)
                    },
                    mouseover: function($event) {
                      _vm.overMenu = true
                    },
                    mouseleave: function($event) {
                      _vm.overMenu = false
                    }
                  }
                },
                [
                  _vm._v(
                    "\n\t\t\t\tENVOYER TOUS LES PRODUITS SELECTIONNES\n                "
                  ),
                  _c("v-icon", [_vm._v("shopping_cart_checkout")])
                ],
                1
              )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !!_vm.search && _vm.search !== "",
              expression: "!!search && search !== ''"
            }
          ],
          staticClass: "mb-3 listProductsCatalog"
        },
        [
          _c(
            "v-card-text",
            [
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headersTousProducts,
                  items: _vm.allProducts,
                  "no-data-text": _vm.$tc("allProducts", 0),
                  "no-results-text": _vm.$tc("results", 0),
                  "rows-per-page-items": [
                    10,
                    25,
                    50,
                    { text: "Toutes", value: -1 }
                  ],
                  "rows-per-page-text": _vm.$t("productsPerPage"),
                  search: _vm.search,
                  "custom-filter": _vm.filterLMessages,
                  "item-key": "id",
                  "select-all": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(props) {
                      return [
                        _c(
                          "tr",
                          [
                            _c(
                              "th",
                              [
                                _c("v-checkbox", {
                                  attrs: {
                                    "input-value": props.all,
                                    indeterminate: props.indeterminate,
                                    primary: "",
                                    "hide-details": ""
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.toggleAll.apply(
                                        null,
                                        arguments
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm._l(props, function(header) {
                              return _c(
                                "th",
                                {
                                  key: header.text,
                                  class: [
                                    "column sortable",
                                    _vm.pagination.descending ? "desc" : "asc",
                                    header.value === _vm.pagination.sortBy
                                      ? "active"
                                      : ""
                                  ],
                                  on: {
                                    click: function($event) {
                                      return _vm.changeSort(header.value)
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", { attrs: { small: "" } }, [
                                    _vm._v("arrow_upward")
                                  ]),
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(header.text) +
                                      "\n              "
                                  )
                                ],
                                1
                              )
                            })
                          ],
                          2
                        )
                      ]
                    }
                  },
                  {
                    key: "items",
                    fn: function(props) {
                      return [
                        _c(
                          "td",
                          { staticClass: "text-xs-right" },
                          [
                            _c("v-checkbox", {
                              attrs: { primary: "", "hide-details": "" },
                              model: {
                                value: props.selected,
                                callback: function($$v) {
                                  _vm.$set(props, "selected", $$v)
                                },
                                expression: "props.selected"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "text-xs-left",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                              }
                            }
                          },
                          [_vm._v(_vm._s(props.item.title))]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "text-xs-left",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                              }
                            }
                          },
                          [_vm._v(_vm._s(props.item.ref))]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "text-xs-left",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                              }
                            }
                          },
                          [_vm._v(_vm._s(props.item.keywords))]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticClass: "text-xs-left",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                              }
                            }
                          },
                          [_vm._v(_vm._s(props.item.price))]
                        ),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-right px-0" },
                          [
                            _vm.checkRouteSendChat
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "secondary--text",
                                      icon: "",
                                      small: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.pushProduct(props.item)
                                      },
                                      mouseover: function($event) {
                                        _vm.overMenu = true
                                      },
                                      mouseleave: function($event) {
                                        _vm.overMenu = false
                                      }
                                    }
                                  },
                                  [
                                    _c("v-icon", [
                                      _vm._v("shopping_cart_checkout")
                                    ])
                                  ],
                                  1
                                )
                              : _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color:
                                        _vm.status === "offline"
                                          ? "grey--text"
                                          : "secondary--text",
                                      icon: "",
                                      small: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.pushProduct(props.item)
                                      },
                                      mouseover: function($event) {
                                        _vm.overMenu = true
                                      },
                                      mouseleave: function($event) {
                                        _vm.overMenu = false
                                      }
                                    }
                                  },
                                  [
                                    _c("v-icon", [
                                      _vm._v("shopping_cart_checkout")
                                    ])
                                  ],
                                  1
                                )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ]),
                model: {
                  value: _vm.selected,
                  callback: function($$v) {
                    _vm.selected = $$v
                  },
                  expression: "selected"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-expansion-panel",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.search || _vm.search === "",
              expression: "!search || search === ''"
            }
          ],
          attrs: { expand: "" }
        },
        _vm._l(_vm.rayons, function(rayon) {
          return _c(
            "v-expansion-panel-content",
            { key: rayon.id },
            [
              _c(
                "div",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("v-icon", { attrs: { color: "primary" } }, [
                    _vm._v("store")
                  ]),
                  _vm._v("\n          " + _vm._s(rayon.title) + "\n          "),
                  _c(
                    "span",
                    { staticClass: "caption grey--text text--darken-1" },
                    [
                      _vm._v(
                        "\n            (\n            " +
                          _vm._s(
                            _vm.$tc("subRayons", rayon.subs.length, {
                              count: rayon.subs.length
                            })
                          ) +
                          " ; \n            " +
                          _vm._s(
                            _vm.$tc("products", rayon.products.length, {
                              count: rayon.products.length
                            })
                          ) +
                          "\n            )\n          "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    { staticClass: "grey lighten-3 px-1" },
                    [
                      rayon.subs.length
                        ? _c(
                            "v-expansion-panel",
                            { attrs: { expand: "" } },
                            _vm._l(rayon.subs, function(sub) {
                              return _c(
                                "v-expansion-panel-content",
                                { key: sub.id, attrs: { avatar: "" } },
                                [
                                  _c(
                                    "div",
                                    {
                                      attrs: { slot: "header" },
                                      slot: "header"
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "primary" } },
                                        [_vm._v("shopping_basket")]
                                      ),
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(sub.title) +
                                          "\n                  "
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "caption grey--text text--darken-1"
                                        },
                                        [
                                          _vm._v(
                                            "\n                    (" +
                                              _vm._s(
                                                _vm.$tc(
                                                  "products",
                                                  sub.products.length,
                                                  { count: sub.products.length }
                                                )
                                              ) +
                                              ")\n                  "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-card",
                                    [
                                      _c(
                                        "v-card-text",
                                        {
                                          staticClass:
                                            "grey lighten-3 pl-1 pr-2"
                                        },
                                        [
                                          sub.products.length
                                            ? _c(
                                                "v-list",
                                                {
                                                  attrs: {
                                                    "two-line": "",
                                                    dense: "",
                                                    subheader: ""
                                                  }
                                                },
                                                _vm._l(sub.products, function(
                                                  product
                                                ) {
                                                  return _c(
                                                    "v-list-tile",
                                                    {
                                                      key: product.id,
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.status ===
                                                          "offline"
                                                            ? ";"
                                                            : _vm.pushProduct(
                                                                product
                                                              )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-tile-content",
                                                        [
                                                          _c(
                                                            "v-list-tile",
                                                            {
                                                              staticClass:
                                                                "grow"
                                                            },
                                                            [
                                                              _c(
                                                                "v-list-tile-avatar",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "grey darken-3"
                                                                  }
                                                                },
                                                                [
                                                                  _c("v-img", {
                                                                    staticClass:
                                                                      "elevation-6",
                                                                    attrs: {
                                                                      src:
                                                                        product.img
                                                                    }
                                                                  })
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-list-tile-content",
                                                                [
                                                                  _c(
                                                                    "v-list-tile-title",
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          product.title
                                                                        ) +
                                                                          " / " +
                                                                          _vm._s(
                                                                            product.price
                                                                          )
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "v-list-tile-action",
                                                        [
                                                          _vm.checkRouteSendChat
                                                            ? _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "secondary--text",
                                                                    icon: "",
                                                                    small: ""
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      return _vm.pushProduct(
                                                                        product
                                                                      )
                                                                    },
                                                                    mouseover: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.overMenu = true
                                                                    },
                                                                    mouseleave: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.overMenu = false
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("v-icon", [
                                                                    _vm._v(
                                                                      "shopping_cart_checkout"
                                                                    )
                                                                  ])
                                                                ],
                                                                1
                                                              )
                                                            : _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      _vm.status ===
                                                                      "offline"
                                                                        ? "grey--text"
                                                                        : "secondary--text",
                                                                    icon: "",
                                                                    small: ""
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      return _vm.pushProduct(
                                                                        product
                                                                      )
                                                                    },
                                                                    mouseover: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.overMenu = true
                                                                    },
                                                                    mouseleave: function(
                                                                      $event
                                                                    ) {
                                                                      _vm.overMenu = false
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _c("v-icon", [
                                                                    _vm._v(
                                                                      "shopping_cart_checkout"
                                                                    )
                                                                  ])
                                                                ],
                                                                1
                                                              )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                }),
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    { staticClass: "grey lighten-3 px-1" },
                    [
                      rayon.products.length
                        ? _c(
                            "v-list",
                            {
                              attrs: {
                                "two-line": "",
                                dense: "",
                                subheader: ""
                              }
                            },
                            _vm._l(rayon.products, function(product) {
                              return _c(
                                "v-list-tile",
                                {
                                  key: product.id,
                                  on: {
                                    click: function($event) {
                                      _vm.status === "offline"
                                        ? ";"
                                        : _vm.pushProduct(product)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "v-list-tile-content",
                                    [
                                      _c(
                                        "v-list-tile",
                                        { staticClass: "grow" },
                                        [
                                          _c(
                                            "v-list-tile-avatar",
                                            {
                                              attrs: { color: "grey darken-3" }
                                            },
                                            [
                                              _c("v-img", {
                                                staticClass: "elevation-6",
                                                attrs: { src: product.img }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-list-tile-content",
                                            [
                                              _c("v-list-tile-title", [
                                                _vm._v(
                                                  _vm._s(product.title) +
                                                    " / " +
                                                    _vm._s(product.price)
                                                )
                                              ])
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-tile-action",
                                    [
                                      _vm.checkRouteSendChat
                                        ? _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "secondary--text",
                                                icon: "",
                                                small: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.pushProduct(
                                                    product
                                                  )
                                                },
                                                mouseover: function($event) {
                                                  _vm.overMenu = true
                                                },
                                                mouseleave: function($event) {
                                                  _vm.overMenu = false
                                                }
                                              }
                                            },
                                            [
                                              _c("v-icon", [
                                                _vm._v("shopping_cart_checkout")
                                              ])
                                            ],
                                            1
                                          )
                                        : _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color:
                                                  _vm.status === "offline"
                                                    ? "grey--text"
                                                    : "secondary--text",
                                                icon: "",
                                                small: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.pushProduct(
                                                    product
                                                  )
                                                },
                                                mouseover: function($event) {
                                                  _vm.overMenu = true
                                                },
                                                mouseleave: function($event) {
                                                  _vm.overMenu = false
                                                }
                                              }
                                            },
                                            [
                                              _c("v-icon", [
                                                _vm._v("shopping_cart_checkout")
                                              ])
                                            ],
                                            1
                                          )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e578526", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e578526","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzCatalogueProduits.vue
// module id = null
// module chunks = 